import "../../../../stylesheets/products";
import AutoNumeric from "autonumeric";
import { managePaymentOptions } from "../../utils";
import { setupAutoNumeric } from "../../../utils";

$(document).ready(function () {
  if (
    window.performance &&
    window.performance.navigation.type ===
    window.performance.navigation.TYPE_BACK_FORWARD
  ) {
    $("#product-quantity-desktop").attr("autocomplete", "off");
    $("#product-quantity-mobile").attr("autocomplete", "off");
  }

  function getMaxTickets($input) {
    const max = parseInt($input.attr("max"), 10);
    return isNaN(max) ? null : max;
  }

  function clampQuantity($input, value) {
    let v = isNaN(value) ? 0 : Math.max(0, value);
    const max = getMaxTickets($input);
    if (max !== null) v = Math.min(max, v);
    return v;
  }

  function updateMaxTicketsError($input, exceeded) {
    $input.toggleClass("is-invalid", exceeded);
    $(".invalid-raffle-quantity").toggleClass("d-block", exceeded);
  }

  function updateStepperButtonsState($input) {
    const $stepper = $input.closest(".campaign-quantity-stepper");
    if (!$stepper.length) return;
    const max = getMaxTickets($input);
    const v = parseInt($input.val(), 10) || 0;
    const reachedMax = max !== null && v >= max;
    $stepper.find('.campaign-quantity-stepper__btn[data-step="1"]').prop("disabled", reachedMax);
    $stepper.find('.campaign-quantity-stepper__btn[data-step="-1"]').prop("disabled", v <= 0);
  }

  $("input.campaign-quantity-input").each(function () {
    updateStepperButtonsState($(this));
  });

  $(document)
    .off("input.r1MaxTickets", "input.campaign-quantity-input")
    .on("input.r1MaxTickets", "input.campaign-quantity-input", function () {
      const $input = $(this);
      const max = getMaxTickets($input);
      const v = parseInt($input.val(), 10);
      updateMaxTicketsError($input, max !== null && v > max);
      updateStepperButtonsState($input);
    });

  $(document)
    .off("click.r1Stepper", ".campaign-quantity-stepper__btn")
    .on("click.r1Stepper", ".campaign-quantity-stepper__btn", function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      if (this.disabled) return;
      const step = parseInt($(this).attr("data-step"), 10) || 0;
      const $input = $(this).closest(".campaign-quantity-stepper").find("input.campaign-quantity-input");
      if (!$input.length) return;
      const current = parseInt($input.val(), 10) || 0;
      const max = getMaxTickets($input);
      const clamped = clampQuantity($input, current + step);
      updateMaxTicketsError($input, step > 0 && max !== null && current + step > max);
      $input.val(String(clamped)).trigger("change");
      updateStepperButtonsState($input);
    });

  function syncRaffleSummaryQuantity() {
    if (!$(".js-summary-ticket-count").length) return;
    const v = parseInt($("#product-quantity-desktop").val(), 10);
    const q = isNaN(v) ? 0 : v;
    $(".js-summary-ticket-count").text("(" + q + ")");
  }

  if ($(".js-summary-ticket-count").length) {
    syncRaffleSummaryQuantity();
  }

  // Cause Products
  $("#product-quantity-desktop").on("change", function (target) {
    const $input = $("#product-quantity-desktop");
    const clamped = clampQuantity($input, parseInt($input.val(), 10));
    if (String(clamped) !== $input.val()) $input.val(String(clamped));
    syncRaffleSummaryQuantity();
    calculateAndUpdateAmount(clamped, 'desktop');
    $("#product-quantity-mobile").val(String(clamped));
    updateStepperButtonsState($input);
    updateStepperButtonsState($("#product-quantity-mobile"));
  });

  $("#product-quantity-mobile").on("change", function (target) {
    const $input = $("#product-quantity-mobile");
    const clamped = clampQuantity($input, parseInt($input.val(), 10));
    if (String(clamped) !== $input.val()) $input.val(String(clamped)); syncRaffleSummaryQuantity();
    calculateAndUpdateAmount(clamped, 'mobile');
    $("#product-quantity-desktop").val(String(clamped));
    updateStepperButtonsState($input);
    updateStepperButtonsState($("#product-quantity-desktop"));
  });

  // Función para calcular el monto (rifa con precios diferenciados o precio normal)
  function calculateAndUpdateAmount(quantity, device) {
    const currency = $("#currency-type")[0]?.value || "clp";
    const raffleContainer = document.querySelector(".app-container.raffle");
    const campaignId = raffleContainer?.getAttribute("data-campaign-id");

    if (campaignId && quantity > 0 && currency === "clp") {
      $.ajax({
        url: "/calculate_raffle_price",
        method: "GET",
        data: {
          campaign_id: campaignId,
          quantity: quantity,
          currency: currency
        },
        success: function (response) {
          let total_amount = response.price;
          update_product_amount(total_amount);
          update_ticket_amount(total_amount, quantity, currency);
        },
        error: function (xhr, status, error) {
          console.error("AJAX error:", { xhr, status, error });
          calculateNormalAmount(quantity, currency);
        }
      });
    } else {
      calculateNormalAmount(quantity, currency);
    }
  }

  function calculateNormalAmount(quantity, currency) {
    let total_amount;
    const priceInput = currency === "clp"
      ? $("#product-quantity-desktop")[0]?.getAttribute("data-price")
      : $("#product-quantity-desktop")[0]?.getAttribute("data-price-usd");

    if (currency === "clp") {
      total_amount = (parseFloat(priceInput) || 0) * quantity;
    } else if (currency === "usd") {
      total_amount = ((parseFloat(priceInput) || 0) * quantity).toString().replace(".", ",");
    }
    update_product_amount(total_amount);
  }
});
export const update_product_currency = (currency) => {
  const quantity = parseInt($("#product-quantity-desktop").val()) || 0;
  const raffleAmounts = document.getElementById("raffle-amounts");

  if (currency == "clp") {
    $("#unitary-price")[0].innerText = new Intl.NumberFormat("es-CL", {
      currency: "CLP",
      style: "currency",
      maximumFractionDigits: 0,
    }).format($("#unitary-price")[0].getAttribute("clp-price"));
    $(".usd-ticket-price").hide();
    $(".clp-ticket-price").show();
  } else if (currency == "usd") {
    $("#unitary-price")[0].innerText = new Intl.NumberFormat("es-CL", {
      currency: "USD",
      style: "currency",
      maximumFractionDigits: 0,
    }).format($("#unitary-price")[0].getAttribute("usd-price"));
    $(".usd-ticket-price").show();
    $(".clp-ticket-price").hide();
  }

  const raffleContainer = document.querySelector(".app-container.raffle");
  const campaignId = raffleContainer?.getAttribute("data-campaign-id");

  if (campaignId) {

    $.ajax({
      url: "/calculate_raffle_price",
      method: "GET",
      data: {
        campaign_id: campaignId,
        quantity: quantity,
        currency: currency
      },
      success: function (response) {
        let total_amount = response.price;
        if (currency === "usd") {
          total_amount = total_amount.toString().replace(".", ",");
        }
        update_product_amount(total_amount);
      },
      error: function () {
        let total_amount;
        if (currency == "clp") {
          total_amount =
            $("#product-quantity-desktop")[0].getAttribute("data-price") *
            quantity;
        } else if (currency == "usd") {
          total_amount = ($("#product-quantity-desktop")[0].getAttribute("data-price-usd") * quantity).toString().replace(".", ",");
        }
        update_product_amount(total_amount);
      }
    });
  } else {
    let total_amount;
    if (currency == "clp") {
      total_amount =
        $("#product-quantity-desktop")[0].getAttribute("data-price") *
        quantity;
    } else if (currency == "usd") {
      total_amount = ($("#product-quantity-desktop")[0].getAttribute("data-price-usd") * quantity).toString().replace(".", ",");
    }
    update_product_amount(total_amount);
  }
};

export const update_ticket_amount = (total_amount, quantity, currency) => {
  const element = currency == "clp" ? ".campaign-product-price.clp-ticket-price.product-input-field.ticket-unit-price" : ".campaign-product-price.usd-ticket-price.product-input-field.ticket-unit-price";
  const amount = total_amount / quantity;
  $(element).text(amount);
  setupAutoNumeric(currency, null, element, "$");
};

export const update_product_amount = (total_amount) => {
  const desktopElement = $("#total_amount_product_desktop");
  const mobileElement = $("#total_amount_product_mobile");
  const amountInput = $("#donator_donation_transactions_attributes_0_amount")[0];
  const currencyVal = $("#currency-type")[0]?.value || "clp";

  if (desktopElement.length) {
    desktopElement.text(total_amount);
    setupAutoNumeric(currencyVal, null, "#total_amount_product_desktop", "$");
    const ticketText = desktopElement.text();
    $(".js-summary-ticket-total").text(ticketText);
  }

  if (mobileElement.length) {
    mobileElement.text(total_amount);
    setupAutoNumeric(currencyVal, null, "#total_amount_product_mobile", "$");
    const ticketText = mobileElement.text();
    $(".js-summary-ticket-total").text(ticketText);
  }

  if (amountInput) {
    amountInput.setAttribute("value", total_amount);
  }
};
export const manageProductsCurrencies = (
  new_product_price,
  new_product_price_usd
) => {
  let local_currency = $("#local-currency")?.[0]?.innerHTML;
  if (!local_currency) {
    return;
  }
  if (
    $("#currency-type")[0].value == "usd" &&
    parseInt(new_product_price_usd) > 0
  ) {
    if (!(parseInt(new_product_price) > 0)) {
      $(".currency_container").hide();
    } else {
      $(".currency_container").show();
    }
  } else if (
    $("#currency-type")[0].value == "usd" &&
    !(parseInt(new_product_price_usd) > 0)
  ) {
    managePaymentOptions(local_currency, "once");
    $(".currency_container").hide();
  } else if (
    $("#currency-type")[0].value == local_currency &&
    parseInt(new_product_price) > 0
  ) {
    if (!(parseInt(new_product_price_usd) > 0)) {
      $(".currency_container").hide();
    } else {
      $(".currency_container").show();
    }
  } else if (
    $("#currency-type")[0].value == local_currency &&
    !(parseInt(new_product_price) > 0)
  ) {
    managePaymentOptions("usd", "once");
    $(".currency_container").hide();
  }
};
